const assetsPath =
  process.env.REACT_APP_ASSETS_PATH || "https://set.live/assets";
export const bucketImageSource = {
  setToolsHeader: `${assetsPath}/artist-portal/header/set-tools.jpg`,
  setLiveHeader: `${assetsPath}/artist-portal/header/set-live.jpg`,
  setFanHeader: `${assetsPath}/artist-portal/header/set-fan.jpg`,
  setBioHeader: `${assetsPath}/artist-portal/header/set-bio.jpg`,
};
